
    (function () {
      var root = document.getElementById("kc-app");
      var header = document.getElementById("kc-header");
      var nav = document.getElementById("kc-nav");
      var cartBtn = document.getElementById("kc-cart");
      var cartN = document.getElementById("kc-cart-n");
      var toast = document.getElementById("kc-toast");
      var stickyBar = document.getElementById("kc-sticky");
      var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      var homeView = root && root.querySelector('.kc-view[data-view="home"]');
      var $ = function (s) { return root.querySelector(s); };
      var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
      var byId = function (id) { return document.getElementById(id); };
      if (!homeView) { return; }

      /* 10 colours sampled from the actual product photos */
      var colorways = [
        { id: "berry", name: "Berry Fizz", strap: "#C43C78", photo: window.KC_IMG['collar-berry'], beads: ["#D98BD6", "#B168B0", "#F7D9D0", "#FFFFFF", "#DCB4B6"] },
        { id: "limeade", name: "Limeade", strap: "#7CC93C", photo: window.KC_IMG['collar-limeade'], beads: ["#C9E64F", "#DBF664", "#9BC624", "#FFFFFF", "#B8CD6D"] },
        { id: "royal", name: "Royal Blue", strap: "#2E5FA8", photo: window.KC_IMG['collar-royal'], beads: ["#5E8CB8", "#99CCF1", "#2E6FB0", "#FFFFFF", "#80A6C7"] },
        { id: "peach", name: "Peach Blush", strap: "#E8777F", photo: window.KC_IMG['collar-peach'], beads: ["#F88A8B", "#EEBFBC", "#DD7375", "#FFFFFF", "#F5CDC9"] },
        { id: "tangerine", name: "Tangerine", strap: "#F2762E", photo: window.KC_IMG['collar-tangerine'], beads: ["#E86A22", "#F7A24B", "#FFC98A", "#FFFFFF", "#D8C0B2"] },
        { id: "cherry", name: "Cherry Pop", strap: "#D13B3B", photo: window.KC_IMG['collar-cherry'], beads: ["#E94D51", "#DF3E44", "#C93339", "#FFFFFF", "#F0A0A2"] },
        { id: "rainbow", name: "Rainbow Pop", strap: "#1C1C1C", photo: window.KC_IMG['collar-rainbow'], beads: ["#E23B3B", "#F5A623", "#F5E14B", "#4FC94F", "#3B9BE8"] },
        { id: "bubblegum", name: "Bubblegum", strap: "#F45A8C", photo: window.KC_IMG['collar-bubblegum'], beads: ["#F45A8C", "#F5A0B2", "#FFC2D1", "#FFFFFF", "#DB8F98"] },
        { id: "sky", name: "Sky Blue", strap: "#35A8D8", photo: window.KC_IMG['collar-sky'], beads: ["#35A8D8", "#82DAEE", "#9AE9F8", "#FFFFFF", "#62C6DE"] },
        { id: "sunshine", name: "Sunshine", strap: "#F0C93B", photo: window.KC_IMG['collar-sunshine'], beads: ["#F0C93B", "#F2EB81", "#F5DF5E", "#FFFFFF", "#E4C134"] }
      ];
      /* 真实牵引绳实拍图（工厂目前拍到的 8 个配色）。
         棚拍光线会让颜色偏一点，实物与同色项圈完全一致。 */
      var leashPhotos = {
        berry: window.KC_IMG['leash-berry'],
        bubblegum: window.KC_IMG['leash-bubblegum'],
        sunshine: window.KC_IMG['leash-sunshine'],
        royal: window.KC_IMG['leash-royal'],
        tangerine: window.KC_IMG['leash-tangerine'],
        cherry: window.KC_IMG['leash-cherry'],
        sky: window.KC_IMG['leash-sky'],
        limeade: window.KC_IMG['leash-limeade'],
        peach: window.KC_IMG['leash-peach'],
        rainbow: window.KC_IMG['leash-rainbow']
      };
      var leashNote = "Studio shot \u2014 the leash you receive is exactly the same colourway as the collar.";
      function leashPhotoFor(id) { return leashPhotos[id] || ""; }
      var sizes = [
        { id: "s", label: "Small", range: "23–25 cm neck" },
        { id: "m", label: "Medium", range: "31–33 cm neck" },
        { id: "l", label: "Large", range: "38–40 cm neck" },
        { id: "xl", label: "X-Large", range: "46–48 cm neck" }
      ];
      var state = { view: "home", colorway: "royal", size: "m", leash: false, leashLen: "120", leashColor: "match", leashName: false, cart: 0, busy: false };
      var NS = "http://www.w3.org/2000/svg";
      root.classList.add("kc-js");

      function pick(list, id, fb) { for (var i = 0; i < list.length; i++) { if (list[i].id === id) { return list[i]; } } return fb; }
      function cw() { return pick(colorways, state.colorway, colorways[0]); }
      function sz() { return pick(sizes, state.size, sizes[1]); }
      function money(v) { return "A$" + v.toFixed(2); }
      function petName() { return (byId("kc-shop-name").value || "").trim().toUpperCase().slice(0, 8); }
      function petNameIsValid(value) {
        return value.length >= 1 && value.length <= 8 && /^[A-Z]+(?:[ -][A-Z]+)*$/.test(value);
      }
      function totals() {
        var leash = state.leash ? 30.00 : 0;
        return { unit: 59.95 + leash, leash: leash };
      }

      var toastTimer;
      function say(msg) {
        toast.textContent = msg;
        toast.setAttribute("data-show", "true");
        clearTimeout(toastTimer);
        toastTimer = setTimeout(function () { toast.setAttribute("data-show", "false"); }, 2200);
      }

      function show(view) {
        state.view = view;
        $$(".kc-view").forEach(function (v) { v.hidden = v.getAttribute("data-view") !== view; });
        $$("#kc-nav [data-nav-view]").forEach(function (a) {
          if (a.getAttribute("data-nav-view") === view) { a.setAttribute("aria-current", "page"); }
          else { a.removeAttribute("aria-current"); }
        });
        requestAnimationFrame(revealAll);
      }

      var io = null;
      function revealAll() {
        var items = $$(".kc-reveal").filter(function (el) { return !el.closest("[hidden]"); });
        if (reduce || !("IntersectionObserver" in window)) {
          items.forEach(function (el) { el.classList.add("kc-in"); });
          $$(".kc-meter").forEach(function (m) { m.setAttribute("data-on", "true"); });
          return;
        }
        if (!io) {
          io = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) {
              if (en.isIntersecting) { en.target.classList.add("kc-in"); io.unobserve(en.target); }
            });
          }, { rootMargin: "0px 0px -6% 0px", threshold: 0.1 });
        }
        items.forEach(function (el) {
          if (el.classList.contains("kc-in")) { return; }
          var r = el.getBoundingClientRect();
          if (r.top < window.innerHeight * 0.92) { el.classList.add("kc-in"); io.unobserve(el); }
          else { io.observe(el); }
        });
        $$(".kc-meter").forEach(function (m) {
          if (m.getBoundingClientRect().top < window.innerHeight) { m.setAttribute("data-on", "true"); }
        });
      }

      function drawCollar(pathId, groupId, beads, label, radius) {
        var path = byId(pathId);
        var group = byId(groupId);
        if (!path || !group) { return; }
        var total = path.getTotalLength();
        var count = 36;
        var start = Math.floor(count / 2) - Math.floor(label.length / 2);
        var r = radius || 13.5;
        group.textContent = "";
        for (var i = 0; i < count; i++) {
          var t = i / (count - 1);
          if (t < 0.07 || t > 0.93) { continue; }
          var pt = path.getPointAtLength(total * t);
          var idx = start + label.length - 1 - i;
          var isLetter = label.length > 0 && idx >= 0 && idx < label.length;
          var rad = isLetter ? r + 2 : r;
          var c = document.createElementNS(NS, "circle");
          c.setAttribute("cx", pt.x.toFixed(1));
          c.setAttribute("cy", pt.y.toFixed(1));
          c.setAttribute("r", rad.toFixed(1));
          c.setAttribute("fill", isLetter ? "#FFFFFF" : beads[i % beads.length]);
          c.setAttribute("stroke", "rgba(14,42,48,.28)");
          c.setAttribute("stroke-width", "1.4");
          group.appendChild(c);
          if (isLetter) {
            var tx = document.createElementNS(NS, "text");
            tx.setAttribute("x", pt.x.toFixed(1));
            tx.setAttribute("y", (pt.y + rad * 0.36).toFixed(1));
            tx.setAttribute("text-anchor", "middle");
            tx.setAttribute("font-size", (rad * 1.05).toFixed(1));
            tx.setAttribute("font-family", "Fraunces, Georgia, serif");
            tx.setAttribute("fill", "#0E2A30");
            tx.textContent = label.charAt(idx);
            group.appendChild(tx);
          }
        }
      }

      function drawDetail() {
        var g = byId("kc-detail-beads");
        if (!g) { return; }
        var arr = cw().beads;
        var out = "";
        for (var i = 0; i < 11; i++) {
          var t = i / 10;
          var x = 52 + t * 420;
          var y = 190 + Math.sin(t * Math.PI) * -34 + (i % 2 ? 4 : -3);
          var r = 15 + (i % 3) * 2.4;
          out += '<circle cx="' + x.toFixed(1) + '" cy="' + y.toFixed(1) + '" r="' + r + '" fill="' + arr[i % arr.length] + '" stroke="rgba(14,42,48,.28)" stroke-width="1.4"/>';
          out += '<ellipse cx="' + (x - r * 0.28).toFixed(1) + '" cy="' + (y - r * 0.34).toFixed(1) + '" rx="' + (r * 0.34).toFixed(1) + '" ry="' + (r * 0.22).toFixed(1) + '" fill="rgba(255,255,255,.55)"/>';
        }
        g.innerHTML = out;
      }

      function drawAll() {
        var b = cw().beads;
        var n = petName();
        drawCollar("kc-hero-path", "kc-hero-beads", b, n, 15);
        drawCollar("kc-editor-path", "kc-editor-beads", b, n, 13);
        drawCollar("kc-shop-path", "kc-shop-beads", b, n, 13.5);
        drawDetail();
      }

      function buildSwatches() {
        var box = byId("kc-swatches");
        box.textContent = "";
        colorways.forEach(function (item) {
          var b = document.createElement("button");
          b.type = "button";
          b.className = "kc-swatch";
          b.setAttribute("aria-pressed", item.id === state.colorway ? "true" : "false");
          var dots = document.createElement("span");
          dots.className = "kc-swatch__dots";
          item.beads.slice(0, 3).forEach(function (c) {
            var i = document.createElement("i");
            i.style.background = c;
            dots.appendChild(i);
          });
          var label = document.createElement("span");
          label.textContent = item.name;
          b.appendChild(dots);
          b.appendChild(label);
          b.addEventListener("click", function () { state.colorway = item.id; renderFull(); });
          box.appendChild(b);
        });
      }


      function buildLeashLen() {
        var box = byId("kc-leashlen");
        if (!box) { return; }
        box.textContent = "";
        [["120", "120 cm", "standard walk"], ["150", "150 cm", "extra room"]].forEach(function (pair) {
          var b = document.createElement("button");
          b.type = "button";
          b.className = "kc-swatch";
          b.setAttribute("aria-pressed", pair[0] === state.leashLen ? "true" : "false");
          var s = document.createElement("span");
          s.textContent = pair[1] + " · " + pair[2];
          b.appendChild(s);
          b.addEventListener("click", function () { state.leashLen = pair[0]; renderFull(); });
          box.appendChild(b);
        });
        var blockEl = byId("kc-leashlen-block");
        if (blockEl) { blockEl.hidden = !state.leash; }
      }

      function leashColorway() {
        return state.leashColor === "match" ? cw() : pick(colorways, state.leashColor, cw());
      }

      function buildLeashColours() {
        var box = byId("kc-leashcolour");
        if (!box) { return; }
        box.textContent = "";
        var match = document.createElement("button");
        match.type = "button";
        match.className = "kc-swatch";
        match.setAttribute("aria-pressed", state.leashColor === "match" ? "true" : "false");
        var dots = document.createElement("span");
        dots.className = "kc-swatch__dots";
        cw().beads.slice(0, 3).forEach(function (c) {
          var i = document.createElement("i"); i.style.background = c; dots.appendChild(i);
        });
        var lab = document.createElement("span");
        lab.textContent = "Match the collar";
        match.appendChild(dots);
        match.appendChild(lab);
        match.addEventListener("click", function () { state.leashColor = "match"; renderFull(); });
        box.appendChild(match);
        colorways.forEach(function (item) {
          var b = document.createElement("button");
          b.type = "button";
          b.className = "kc-swatch";
          b.setAttribute("aria-pressed", state.leashColor === item.id ? "true" : "false");
          var d = document.createElement("span");
          d.className = "kc-swatch__dots";
          item.beads.slice(0, 3).forEach(function (c) {
            var i = document.createElement("i"); i.style.background = c; d.appendChild(i);
          });
          var s = document.createElement("span");
          s.textContent = item.name;
          b.appendChild(d);
          b.appendChild(s);
          b.addEventListener("click", function () { state.leashColor = item.id; renderFull(); });
          box.appendChild(b);
        });
        var hint = byId("kc-leashcolour-name");
        if (hint) {
          hint.textContent = state.leashColor === "match" ? "matches the collar" : leashColorway().name;
        }
        var lcNow = leashColorway();
        var lpNow = leashPhotoFor(lcNow.id);
        var thumb = byId("kc-leash-thumb");
        if (thumb) {
          thumb.src = lpNow;
          thumb.hidden = !lpNow;
          thumb.alt = lpNow ? lcNow.name + " matching beaded dog leash" : "";
        }
        var pnote = byId("kc-leash-phototext");
        if (pnote) {
          pnote.textContent = lpNow
            ? "Real photo of the " + lcNow.name + " leash. " + leashNote
            : "The " + lcNow.name + " leash is in stock and ships strung in the same colourway as this collar — the studio photo is still coming.";
        }
      }

      function drawLeash() {
        var path = byId("kc-leash-strand");
        var group = byId("kc-leash-beads");
        var handle = byId("kc-leash-handle");
        if (!path || !group) { return; }
        var lc = leashColorway();
        if (handle) { handle.setAttribute("stroke", lc.strap); }
        var total = path.getTotalLength();
        var count = 46;
        var letters = state.leashName ? petName() : "";
        group.textContent = "";
        for (var i = 0; i < count; i++) {
          var t = i / (count - 1);
          var pt = path.getPointAtLength(total * t);
          var li = letters.length - 1 - (i - 2);
          var isLetter = letters.length > 0 && li >= 0 && li < letters.length;
          var c = document.createElementNS(NS, "circle");
          c.setAttribute("cx", pt.x.toFixed(1));
          c.setAttribute("cy", pt.y.toFixed(1));
          c.setAttribute("r", isLetter ? "11.5" : "10");
          c.setAttribute("fill", isLetter ? "#FFFFFF" : lc.beads[i % lc.beads.length]);
          c.setAttribute("stroke", "rgba(14,42,48,.28)");
          c.setAttribute("stroke-width", "1.3");
          group.appendChild(c);
          if (isLetter) {
            var tx = document.createElementNS(NS, "text");
            tx.setAttribute("x", pt.x.toFixed(1));
            tx.setAttribute("y", (pt.y + 4).toFixed(1));
            tx.setAttribute("text-anchor", "middle");
            tx.setAttribute("font-size", "12");
            tx.setAttribute("font-family", "Fraunces, Georgia, serif");
            tx.setAttribute("fill", "#0E2A30");
            tx.textContent = letters.charAt(li);
            group.appendChild(tx);
          }
        }
      }

      function buildSizes() {
        var box = byId("kc-sizes");
        box.textContent = "";
        sizes.forEach(function (item) {
          var b = document.createElement("button");
          b.type = "button";
          b.className = "kc-size";
          b.setAttribute("aria-pressed", item.id === state.size ? "true" : "false");
          var strong = document.createElement("b");
          strong.textContent = item.label;
          var span = document.createElement("span");
          span.textContent = item.range;
          b.appendChild(strong);
          b.appendChild(span);
          b.addEventListener("click", function () { state.size = item.id; renderFull(); });
          box.appendChild(b);
        });
      }

      function cardArt(item) {
        var out = '<svg viewBox="0 0 320 240" aria-hidden="true"><g>';
        for (var i = 0; i < 9; i++) {
          var x = 34 + i * 30;
          var y = 150 + Math.sin(i * 0.72) * 20;
          out += '<circle cx="' + x + '" cy="' + y.toFixed(1) + '" r="13" fill="' + item.beads[i % item.beads.length] + '" stroke="rgba(14,42,48,.26)" stroke-width="1.4"/>';
        }
        "KANDI".split("").forEach(function (ch, j) {
          var x = 100 + j * 30;
          var y = 150 + Math.sin((j + 3) * 0.72) * 20;
          out += '<circle cx="' + x + '" cy="' + y.toFixed(1) + '" r="14.5" fill="#fff" stroke="rgba(14,42,48,.26)" stroke-width="1.4"/>';
          out += '<text x="' + x + '" y="' + (y + 5).toFixed(1) + '" text-anchor="middle" font-size="14" font-family="Fraunces, Georgia, serif" fill="#0E2A30">' + ch + "</text>";
        });
        return out + "</g></svg>";
      }

      /* buildBest() 已删除：首页商品卡现在由 templates/index.liquid 用真实 Shopify
         商品渲染成 <a href="{{ product.url }}">，不再是写死的假数据和假 Quick add。 */

      function buildTray() {
        var tray = byId("kc-tray");
        var n = petName();
        var beads = cw().beads;
        tray.textContent = "";
        var len = Math.max(3, Math.min(9, n.length || 4));
        for (var i = 0; i < len; i++) {
          var b = document.createElement("span");
          b.className = "kc-bead";
          var ch = n.charAt(i);
          if (ch) {
            b.style.setProperty("--bc", beads[(i + 1) % beads.length]);
            b.textContent = ch;
          } else {
            b.setAttribute("data-blank", "true");
            b.textContent = "·";
          }
          b.style.animationDelay = (i * 45) + "ms";
          tray.appendChild(b);
        }
      }

      /* 没有实拍的配色：用真实珠子配色画一张示意图（不是照片，页面上会写明）。 */
      function leashIllustration(item) {
        var beads = (item.beads && item.beads.length) ? item.beads : ["#FFFFFF"];
        var cx = 100, cy = 72, rx = 52, ry = 38, n = 24, out = "";
        out += '<svg class="kc-illu" viewBox="0 0 200 168" role="img" aria-label="' + item.name + ' leash, illustration in the real bead colours">';
        out += '<path d="M54 104 C 12 108, 10 148, 54 148 C 86 148, 94 130, 102 110" fill="none" stroke="' + item.strap + '" stroke-width="12" stroke-linecap="round"/>';
        out += '<rect x="98" y="98" width="17" height="11" rx="5" fill="#C9A227" stroke="#8C6A16" stroke-width="1"/>';
        for (var b = 0; b < n; b++) {
          var a = (b / n) * Math.PI * 2 + 0.6;
          var x = cx + Math.cos(a) * rx;
          var y = cy + Math.sin(a) * ry;
          var white = (b % 6 === 2);
          out += '<circle cx="' + x.toFixed(1) + '" cy="' + y.toFixed(1) + '" r="9" fill="' + (white ? "#FFFFFF" : beads[b % beads.length]) + '" stroke="rgba(14,42,48,.22)" stroke-width="1.1"/>';
        }
        return out + "</svg>";
      }

      function buildLeashGrid() {
        var box = byId("kc-leash-grid");
        if (!box) { return; }
        box.textContent = "";
        colorways.forEach(function (item, i) {
          var lp = leashPhotoFor(item.id);
          var card = document.createElement("figure");
          card.className = "kc-leash-pair kc-reveal";
          card.setAttribute("data-delay", String(i % 4));
          var right = lp
            ? '<img src="' + lp + '" alt="' + item.name + ' matching beaded dog leash" loading="lazy" decoding="async">'
            : leashIllustration(item);
          card.innerHTML =
            '<div class="kc-leash-pair__row">' +
              '<img src="' + item.photo + '" alt="' + item.name + ' beaded dog collar" loading="lazy" decoding="async">' +
              right +
            "</div>" +
            "<figcaption><b>" + item.name + "</b><span>collar + matching leash</span>" +
              (lp
                ? "<em>same colourway</em>"
                : '<em class="kc-illu-note">leash shown as an illustration — real photo on the way</em><span class="kc-instock">In stock</span>') +
            "</figcaption>";
          card.addEventListener("click", function () {
            state.colorway = item.id;
            state.leash = true;
            var cb = byId("kc-leash");
            if (cb) { cb.checked = true; }
            show("shop");
            renderFull();
          });
          box.appendChild(card);
        });
      }

      function buildRack() {
        var rail = byId("kc-rack");
        if (!rail) { return; }
        rail.textContent = "";
        colorways.forEach(function (item) {
          var b = document.createElement("button");
          b.type = "button";
          b.className = "kc-photo-card";
          var lp = leashPhotoFor(item.id);
          b.innerHTML =
            '<img src="' + item.photo + '" alt="' + item.name + ' beaded dog collar with a personalised name" loading="lazy" decoding="async">' +
            "<b>" + item.name + "</b>" +
            "<span>15 mm beads · collar + matching leash</span>" +
            (lp
              ? '<img class="kc-photo-card__leash" src="' + lp + '" alt="' + item.name + ' matching beaded dog leash" loading="lazy" decoding="async">'
              : '<span class="kc-photo-card__leash kc-photo-card__leash--pending">Matching leash in stock · photo soon</span>');
          b.addEventListener("click", function () {
            state.colorway = item.id;
            show("shop");
            renderFull();
          });
          rail.appendChild(b);
        });

        // 每个项圈都有同色牵引绳 —— 这里用真实实拍图。
        var cta = document.createElement("button");
        cta.type = "button";
        cta.className = "kc-rail-cta";
        cta.innerHTML =
          '<img class="kc-photo-card__leash kc-photo-card__leash--hero" src="' + leashPhotos.berry + '" alt="Beaded dog leash in Berry Fizz with a gold swivel clasp and stitched handle" loading="lazy" decoding="async">' +
          "<b>Every collar has a matching leash</b>" +
          "<span>120 / 150 cm, strung in exactly the same beads and the same colour as the collar. Ten colourways.</span>" +
          "<span style='text-decoration:underline'>Add the leash to your set →</span>";
        cta.addEventListener("click", function () {
          state.leash = true;
          var box = byId("kc-leash");
          if (box) { box.checked = true; }
          show("shop");
          renderFull();
        });
        rail.appendChild(cta);

        buildRailNav();
      }

      var railTimer = null;

      function railStep(rail) {
        var card = rail.children[0];
        if (!card) { return rail.clientWidth; }
        var gap = parseFloat(getComputedStyle(rail).columnGap || "16") || 16;
        return card.getBoundingClientRect().width + gap;
      }

      function buildRailNav() {
        var rail = byId("kc-rack"), dots = byId("kc-rack-dots");
        var prev = byId("kc-rack-prev"), next = byId("kc-rack-next");
        if (!rail || !dots) { return; }
        var cards = Array.prototype.slice.call(rail.children);
        dots.textContent = "";
        cards.forEach(function (c, i) {
          var d = document.createElement("button");
          d.type = "button";
          d.className = "kc-rail-dot";
          d.setAttribute("aria-label", "Go to item " + (i + 1));
          d.addEventListener("click", function () {
            rail.scrollTo({ left: i * railStep(rail), behavior: "smooth" });
          });
          dots.appendChild(d);
        });
        function index() {
          return Math.max(0, Math.min(cards.length - 1, Math.round(rail.scrollLeft / railStep(rail))));
        }
        function paint() {
          var i = index();
          Array.prototype.forEach.call(dots.children, function (d, k) {
            d.setAttribute("data-on", k === i ? "true" : "false");
          });
          if (prev) { prev.disabled = rail.scrollLeft <= 2; }
          if (next) { next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2; }
        }
        rail.onscroll = paint;
        if (prev) {
          prev.onclick = function () {
            rail.scrollTo({ left: Math.max(0, (index() - 1) * railStep(rail)), behavior: "smooth" });
          };
        }
        if (next) {
          next.onclick = function () {
            rail.scrollTo({ left: (index() + 1) * railStep(rail), behavior: "smooth" });
          };
        }
        paint();

        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) { return; }
        var pause = function () { rail.__paused = true; };
        var play = function () { rail.__paused = false; };
        ["pointerenter", "focusin", "touchstart"].forEach(function (e) {
          rail.addEventListener(e, pause, { passive: true });
        });
        ["pointerleave", "focusout", "touchend"].forEach(function (e) {
          rail.addEventListener(e, play, { passive: true });
        });
        clearInterval(railTimer);
        railTimer = setInterval(function () {
          if (rail.__paused || document.hidden || !rail.offsetParent) { return; }
          var max = rail.scrollWidth - rail.clientWidth;
          var nxt = rail.scrollLeft + railStep(rail);
          rail.scrollTo({ left: nxt > max - 6 ? 0 : nxt, behavior: "smooth" });
        }, 4200);
      }

      function buildFlatSizes() {
        var svg = byId("kc-flat");
        if (!svg) { return; }
        var NS2 = "http://www.w3.org/2000/svg";
        var old = svg.querySelector("g.kc-flat-rows");
        if (old) { old.remove(); }
        var layer = document.createElementNS(NS2, "g");
        layer.setAttribute("class", "kc-flat-rows");
        svg.appendChild(layer);
        var rows = [["S", "Small", 25], ["M", "Medium", 33], ["L", "Large", 40], ["XL", "X-Large", 48]];
        var SC = 10, X0 = 26, TOP = 44, GAP = 112;
        var pal = cw().beads;
        var mk = function (tag, attrs, text) {
          var el = document.createElementNS(NS2, tag);
          Object.keys(attrs).forEach(function (k) { el.setAttribute(k, attrs[k]); });
          if (text) { el.textContent = text; }
          layer.appendChild(el);
          return el;
        };
        rows.forEach(function (r, i) {
          var len = r[2] * SC;
          var y = TOP + i * GAP;
          var strapW = 44;
          // strap + gold clasp + D-ring
          mk("rect", { x: X0, y: y - 12, width: strapW, height: 24, rx: 12, fill: "var(--teal-ink)" });
          mk("rect", { x: X0 + 5, y: y - 9, width: 34, height: 18, rx: 9, fill: "url(#kc-gold-flat)", stroke: "#9C7223", "stroke-width": 1 });
          mk("circle", { cx: X0 + strapW + 9, cy: y, r: 9, fill: "none", stroke: "url(#kc-gold-flat)", "stroke-width": 4 });
          // beads
          var bx0 = X0 + strapW + 24;
          var bx1 = X0 + len;
          var span = bx1 - bx0;
          var n = Math.max(3, Math.round(span / 17));
          var nameLetters = ["L", "U", "N", "A"];
          var mid = Math.floor(n / 2);
          for (var b = 0; b < n; b++) {
            var x = bx0 + (span * b) / (n - 1);
            var isLetter = b >= mid - 2 && b < mid + 2;
            mk("circle", {
              cx: x.toFixed(1), cy: y, r: isLetter ? 9.5 : 8.5,
              fill: isLetter ? "#FFFFFF" : pal[b % pal.length],
              stroke: "rgba(14,42,48,.28)", "stroke-width": 1.3
            });
            if (isLetter && n > 8) {
              mk("text", {
                x: x.toFixed(1), y: (y + 3.4).toFixed(1), "text-anchor": "middle",
                "font-family": "Fraunces, Georgia, serif", "font-size": "10", fill: "#0E2A30"
              }, nameLetters[b - (mid - 2)]);
            }
          }
          // dimension line
          var dy = y + 34;
          mk("path", { d: "M" + X0 + " " + dy + " H" + (X0 + len), stroke: "var(--ink)", "stroke-width": 1.4, fill: "none" });
          mk("path", { d: "M" + X0 + " " + (dy - 7) + " V" + (dy + 7) + " M" + (X0 + len) + " " + (dy - 7) + " V" + (dy + 7), stroke: "var(--ink)", "stroke-width": 1.4, fill: "none" });
          mk("text", {
            x: (X0 + len / 2).toFixed(1), y: (dy + 22).toFixed(1), "text-anchor": "middle",
            "font-family": "Inter, sans-serif", "font-size": "12.5", "font-weight": "600", fill: "var(--ink)"
          }, r[1] + " · " + r[2] + " cm (" + (r[2] / 2.54).toFixed(1) + " in)");
          mk("text", {
            x: (X0 + len / 2).toFixed(1), y: (dy + 40).toFixed(1), "text-anchor": "middle",
            "font-family": "Inter, sans-serif", "font-size": "11.5", fill: "#5C7480"
          }, "fits neck " + (r[2] - 2) + "–" + r[2] + " cm");
        });
      }

      function syncLabels() {
        var n = petName();
        var st = totals();
        byId("kc-shop-title").textContent = n ? "The " + n.charAt(0) + n.slice(1).toLowerCase() + " Collar" : "The Name Collar";
        byId("kc-shop-price").textContent = money(st.unit);
        var notes = ["includes name beads"];
        if (st.leash > 0) { notes.push("set price — you save A$36.95"); }
        byId("kc-shop-note").textContent = notes.join(" · ");
        byId("kc-add-total").textContent = money(st.unit);
        byId("kc-shop-colourname").textContent = cw().name + " · " + sz().label;
        byId("kc-shop-count").textContent = n.length + "/8";
        byId("kc-editor-count").textContent = n.length + "/8";
        byId("kc-addon").setAttribute("data-on", state.leash ? "true" : "false");
        byId("kc-shop-leash").setAttribute("opacity", state.leash ? "1" : "0");
        // Studio photo：勾了牵引绳就显示"左项圈 + 右牵引绳"的合成图，没勾就只显示项圈
        var photoEl = byId("kc-photo");
        var setPhoto = window.KC_IMG["set-" + cw().id];
        var wantPhoto = (state.leash && setPhoto) ? setPhoto : cw().photo;
        if (photoEl && photoEl.getAttribute("src") !== wantPhoto) {
          photoEl.src = wantPhoto;
          photoEl.alt = state.leash
            ? cw().name + " beaded collar with the matching leash"
            : cw().name + " beaded dog collar";
        }
        // "Leash" 标签：用真的棚拍照片（跟着牵引绳颜色变），不再是矢量图
        var leashPhotoEl = byId("kc-leash-photo");
        var wantLeashPhoto = leashPhotoFor(leashColorway().id);
        if (leashPhotoEl && wantLeashPhoto && leashPhotoEl.getAttribute("src") !== wantLeashPhoto) {
          leashPhotoEl.src = wantLeashPhoto;
          leashPhotoEl.alt = leashColorway().name + " beaded leash — gold swivel clasp and stitched handle";
        }
        byId("kc-sticky-price").textContent = money(st.unit);
        byId("kc-sticky-name").textContent = (n || "Name") + " · " + sz().label + " · " + cw().name;
      }

      function renderFull() {
        buildSwatches();
        buildLeashLen();
        buildLeashColours();
        buildSizes();
        buildRack();
        buildFlatSizes();
        buildTray();
        syncLabels();
        drawAll();
        drawLeash();
        revealAll();
      }
      function renderQuick() {
        buildTray();
        syncLabels();
        drawAll();
      }

      /* === 真正接上 Shopify ===
         原来这里只是 state.cart + 1 然后弹个提示（假加购，什么都进不了 Shopify 购物车）。
         现在按当前选中的颜色/尺码，在 window.KC_SHOP（templates/index.liquid 用真实商品生成）里
         查出真实变体 ID，POST 到 /cart/add.js，成功后跳到购物车。 */
      function realVariantId() {
        var shop = window.KC_SHOP || {};
        var colour = cw().name;
        if (state.leash) {
          if (!shop.set || !shop.set.map) { return null; }
          return shop.set.map[colour + "|" + sz().label + "|" + state.leashLen + " cm"] || null;
        }
        if (!shop.collar || !shop.collar.map) { return null; }
        return shop.collar.map[colour + "|" + sz().label] || null;
      }

      function addToCart(msg) {
        var name = petName();
        if (!petNameIsValid(name)) {
          show("shop");
          byId("kc-shop-name").setAttribute("aria-invalid", "true");
          shopNameError.hidden = false;
          byId("kc-shop-name").focus();
          say("Add your dog's name using 1–8 letters");
          return;
        }
        byId("kc-shop-name").removeAttribute("aria-invalid");
        var variantId = realVariantId();
        var label = byId("kc-add-label");
        if (!variantId) {
          say("Sorry — that colour and size isn't available yet.");
          if (label) { label.textContent = "Add to cart"; }
          return;
        }
        var props = {};
        // 刻字名字（项圈）
        if (name) { props["Collar engraving"] = name; }
        // 牵引绳的选项也一起写进订单：不然发货时不知道要串什么颜色、要不要刻字
        if (state.leash) {
          var lcName = leashColorway().name;
          props["Leash colour"] = state.leashColor === "match" ? lcName + " (matches collar)" : lcName;
          props["Leash length"] = state.leashLen + " cm";
          props["Leash engraving"] = (state.leashName && name) ? name : "No name on leash";
        }
        var item = { id: variantId, quantity: 1 };
        if (Object.keys(props).length) { item.properties = props; }
        if (label) { label.textContent = "Adding…"; }

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ items: [item] })
        }).then(function (r) {
          return r.json().then(function (data) { return { ok: r.ok, data: data }; });
        }).then(function (res) {
          if (!res.ok) {
            say((res.data && (res.data.description || res.data.message)) || "Sorry — that one just sold out.");
            if (label) { label.textContent = "Add to cart"; }
            return;
          }
          state.cart += 1;
          if (cartN) { cartN.textContent = String(state.cart); }
          cartBtn.setAttribute("data-pop", "true");
          setTimeout(function () { cartBtn.removeAttribute("data-pop"); }, 500);
          if (label) { label.textContent = "Added ✓"; }
          say(msg || "Added to cart");
          window.location.href = "/cart";
        }).catch(function () {
          say("Couldn't reach the cart — please try again.");
          if (label) { label.textContent = "Add to cart"; }
        });
      }

      var editorInput = byId("kc-editor-input");
      var shopInput = byId("kc-shop-name");
      var shopNameError = byId("kc-shop-name-error");
      editorInput.addEventListener("input", function () {
        shopInput.value = editorInput.value.toUpperCase();
        if (petNameIsValid(petName())) {
          shopInput.removeAttribute("aria-invalid");
          shopNameError.hidden = true;
        }
        renderQuick();
      });
      shopInput.addEventListener("input", function () {
        editorInput.value = shopInput.value.toUpperCase();
        if (petNameIsValid(petName())) {
          shopInput.removeAttribute("aria-invalid");
          shopNameError.hidden = true;
        }
        renderQuick();
      });

      byId("kc-leash").addEventListener("change", function (e) {
        state.leash = e.target.checked;
        renderFull();
      });

      function saveCustomerEmail(email, tags) {
        var body = new URLSearchParams();
        body.set("form_type", "customer");
        body.set("utf8", "✓");
        body.set("contact[email]", email);
        body.set("contact[tags]", tags);
        body.set("customer[accepts_marketing]", "on");
        return fetch("/contact", {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            "Accept": "text/html"
          },
          body: body.toString(),
          credentials: "same-origin",
          redirect: "follow"
        }).then(function (response) {
          if (!response.ok) { throw new Error("Subscription request failed"); }
          return response;
        });
      }

      byId("kc-custom-send").addEventListener("click", function () {
        var email = byId("kc-custom-email").value.trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { say("Enter a valid email address"); return; }
        var button = this;
        button.disabled = true;
        button.textContent = "Saving…";
        saveCustomerEmail(email, "newsletter,custom-colour-request").then(function () {
          say("Request saved — we'll email you when your colour lands");
          byId("kc-custom-email").value = "";
        }).catch(function () {
          say("Couldn't save that request — please try again");
        }).finally(function () {
          button.disabled = false;
          button.textContent = "Request";
        });
      });

      byId("kc-leashname").addEventListener("change", function (e) {
        state.leashName = e.target.checked;
        byId("kc-leashname-wrap").setAttribute("data-on", state.leashName ? "true" : "false");
        drawLeash();
        say(state.leashName ? "Name added to the leash too" : "Leash without a name");
      });

      byId("kc-add").addEventListener("click", function () {
        if (state.busy) { return; }
        state.busy = true;
        addToCart("Added · " + money(totals().unit));
        setTimeout(function () { state.busy = false; }, 1200);
      });

      byId("kc-sticky-add").addEventListener("click", function () {
        addToCart("Added · " + money(totals().unit));
      });

      cartBtn.addEventListener("click", function () {
        say(state.cart ? state.cart + " item" + (state.cart > 1 ? "s" : "") + " in your cart" : "Your cart is empty");
      });

      root.addEventListener("click", function (e) {
        var go = e.target.closest("[data-goto]");
        if (!go) { return; }
        show(go.getAttribute("data-goto"));
        if (go.getAttribute("data-goto") === "shop" && window.innerWidth < 900) {
          window.scrollTo({ top: 0, behavior: reduce ? "auto" : "smooth" });
        }
      });

      $$(".kc-thumb").forEach(function (t) {
        t.addEventListener("click", function () {
          $$(".kc-thumb").forEach(function (x) { x.setAttribute("aria-pressed", "false"); });
          t.setAttribute("aria-pressed", "true");
          var stage = byId("kc-stage");
          var wanted = t.getAttribute("data-stage") || "photo";
          if (stage) { stage.setAttribute("data-view", wanted); }
          if (wanted === "preview") { drawAll(); }
        });
      });

      $$(".kc-acc").forEach(function (acc) {
        var btn = acc.querySelector(".kc-acc__btn");
        var panel = acc.querySelector(".kc-acc__panel");
        btn.addEventListener("click", function () {
          var open = acc.getAttribute("data-open") === "true";
          acc.setAttribute("data-open", open ? "false" : "true");
          panel.style.height = open ? "0px" : panel.firstElementChild.offsetHeight + "px";
        });
      });

      byId("kc-subscribe").addEventListener("click", function () {
        var email = byId("kc-email").value.trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { say("Enter a valid email address"); return; }
        if (!byId("kc-consent").checked) { say("Please agree to receive the opening offer"); return; }
        var button = this;
        button.disabled = true;
        button.textContent = "Joining…";
        saveCustomerEmail(email, "newsletter").then(function () {
          byId("kc-code").hidden = false;
          say("You're in — copy code KANDI20");
        }).catch(function () {
          say("Couldn't join right now — please try again");
        }).finally(function () {
          button.disabled = false;
          button.textContent = "Join & show my code";
        });
      });
      byId("kc-copy").addEventListener("click", function () {
        if (navigator.clipboard) {
          navigator.clipboard.writeText("KANDI20").then(function () { say("KANDI20 copied"); }).catch(function () { say("KANDI20"); });
        } else { say("KANDI20"); }
      });

      var ticking = false;
      window.addEventListener("scroll", function () {
        if (ticking) { return; }
        ticking = true;
        requestAnimationFrame(function () {
          header.setAttribute("data-stuck", window.scrollY > 12 ? "true" : "false");
          stickyBar.setAttribute("data-show", state.view === "shop" && window.scrollY > 420 ? "true" : "false");
          ticking = false;
        });
      }, { passive: true });
      window.addEventListener("resize", revealAll);

      // buildLeashGrid() 已停用：首页那段 10 张配对卡片已删除（与十配色轮播重复）
      renderFull();
      var requestedView = new URLSearchParams(window.location.search).get("view");
      show(requestedView === "size" || requestedView === "shop" ? requestedView : "home");
      setTimeout(revealAll, 80);
      [260, 700, 1400, 2400].forEach(function (t) { setTimeout(revealAll, t); });
      document.addEventListener("scroll", revealAll, { passive: true });
      window.addEventListener("load", revealAll);
    })();
  
